<template>
  <div>
    <breadcrumb-bar :crumbs="[{name:'Administrative Settings'},{name: 'Data Import'}]"></breadcrumb-bar>
    <div class="col-md-12">
      <div class="row">
        <div class="portlet light">
          <div class="portlet-title">
            <div class="caption caption-md">
              <span class="caption-subject bold uppercase">Data Import</span>
            </div>
          </div>
          <div class="portlet-body">
            <ul class="list-group" >
              <li class="list-group-item">
                <h4>Import File</h4>
                <router-link :to="{ name: 'Imports' }" tag="button" class="btn green pull-right import-btn">
                  <i aria-hidden="true" class="fa fa-check-square-o"></i>
                  Continue
                </router-link>
              </li>
              <li class="list-group-item">
                <h4>Import History</h4>
                <router-link :to="{ name: 'Imports History' }" tag="button" class="btn green pull-right import-btn">
                  <i aria-hidden="true" class="fa fa-check-square-o"></i>
                  Continue
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs'

  export default {
    components: {
      'breadcrumb-bar': Breadcrumbs,
    }
  }
</script>
<style scoped>
  .import-btn {
    margin-top: 3px;
  }
  .list-group-item {
    margin-bottom: 20px;
  }
  h4 {
    display: inline-block;
    width: calc(100% - 190px);
  }
</style>



// WEBPACK FOOTER //
// ImportsSelect.vue?46e6b46e